import {
  ABOUT_STATE,
  HOW_IT_WORKS_STATE,
  INITIAL_PAGE_STATE,
  REPORT_PAGE_STATE,
  NEW_LOGIN_STATE,
  MANAGE_STATE,
  LOGIN_STATE,
  REMEDIATIONS_STATE,
  LST_UPGRADE,
  ADDONS_SETTINGS_STATE,
  FORGOT_PASSWORD_STATE,
  RECOVERY_STATE,
} from 'constants/constants';
import { Trigger } from 'types/trigger';
import { RemediationRuleViews, REMEDIATION_RULE_VIEW_STATES, Views, ViewsList } from './types';

const getRemediationRuleView = (page: string): RemediationRuleViews | undefined =>
  Object.values(RemediationRuleViews).find((view) => REMEDIATION_RULE_VIEW_STATES[view] === page);

interface UseInitialPageViewParams {
  page: string;
  trigger: Trigger;
  isWidgetReady: boolean;
  isLogged: boolean;
}

export const getInitialPageView = ({
  page,
  trigger,
  isWidgetReady,
  isLogged,
}: UseInitialPageViewParams): Views | null => {
  // First check for manage-skeleton page condition
  if (!isWidgetReady) {
    return ViewsList.SkeletonPage;
  }

  const remediationRuleView = getRemediationRuleView(page);
  if (remediationRuleView) {
    return remediationRuleView;
  }

  switch (page) {
    case INITIAL_PAGE_STATE:
      return trigger === Trigger.Lst ? ViewsList.InitialPageLst : ViewsList.InitialPage;

    case REPORT_PAGE_STATE:
      return ViewsList.ReportPage;

    case ABOUT_STATE:
      return ViewsList.AboutPage;

    case HOW_IT_WORKS_STATE:
      return ViewsList.HowItWorksPage;

    case NEW_LOGIN_STATE:
      // if user is logged in, it loads the Manage page, else the new login page
      return isLogged ? ViewsList.Manage : ViewsList.Login;

    case LOGIN_STATE: {
      // if user is logged in, it loads the Manage page, else the old login page
      return isLogged ? ViewsList.Manage : null;
    }

    case FORGOT_PASSWORD_STATE:
      return ViewsList.ForgotPassword;

    case RECOVERY_STATE:
      return ViewsList.Recovery;

    case MANAGE_STATE:
      return ViewsList.Manage;

    case LST_UPGRADE:
      return ViewsList.LstUpgrade;

    case REMEDIATIONS_STATE:
      return ViewsList.RemediationsList;

    case ADDONS_SETTINGS_STATE:
      return ViewsList.AddonsAndSettings;
    default:
      return null;
  }
};
